import { PAYMENTS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import paymentsTypes from '../../constants/paymentsTypes'
import { axios } from '../../services'

const send_receipt_request = () => {
  return {
    type: paymentsTypes.receipt.request
  }
}

const send_receipt_success = () => {
  return {
    type: paymentsTypes.receipt.success
  }
}

const send_receipt_failure = (messages) => {
  return {
    type: paymentsTypes.receipt.failure,
    payload: messages
  }
}

const send_receipt = (payment_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(send_receipt_request())

    // Request
    axios.post(
      formatRoute(PAYMENTS_ROUTES.send_receipt, {id: payment_id})
    ).then( response => {
      // success
      dispatch( send_receipt_success() )
      window.showSnackbar('success', 'The receipt has been sent to the Test Taker')
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [error]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( send_receipt_failure(errors))
    })
  }
}

export {
  send_receipt,
}



// WEBPACK FOOTER //
// ./src/js/actions/payments/send_receipt.js